import React, {Component} from 'react';
import {Button, Modal, ModalBody, ModalFooter, ModalHeader,} from "reactstrap";
import PropTypes from 'prop-types';
import assets from "../../util/assets";

class CommanModal extends Component {

    render() {
        const awaitStyle = {
            awaitHead: {
                //height: "24px",
                //width: "196px",
                color: "#58595B",
                fontFamily: "Open Sans",
                fontSize: "18px",
                fontWeight: "600",
                letterSpacing: "0",
                lineHeight: "24px",
                textAlign: "center",
            },
            awaitBody: {
                //height: "34px",
                //width: "312px",
                color: "#58595B",
                fontFamily: "Open Sans",
                fontSize: "12px",
                letterSpacing: "0",
                lineHeight: "17px",
                textAlign: "center",
                padding: "0% 9%",
            },
            okButton: {
                //height: "40px",
                //width: "136px",
                borderRadius: "2px",
                backgroundColor: "#1B75BC",
            },
            okButtonText: {
                //height: "19px",
                //width: "20px",
                color: "#FFFFFF",
                fontFamily: "Open Sans",
                fontSize: "14px",
                fontWeight: "600",
                letterSpacing: "0",
                lineHeight: "19px",
                textAlign: "center",
            },
            confirmationContainer:{
                display: 'flex',
                justifyContent: "center"
            },
            confirmationNegativeBtn:{
                minWidth:136,
                borderRadius: "2px",
                backgroundColor: "#FFFFFF",
                borderColor: "#58595B"
            },
            confirmationNegativeBtnText: {
                //height: "19px",
                //width: "20px",
                color: "#58595B",
                fontFamily: "Open Sans",
                fontSize: "14px",
                fontWeight: "600",
                letterSpacing: "0",
                lineHeight: "19px",
                textAlign: "center",
            },
            confirmationPositiveBtn:{
                minWidth:136,
                marginLeft:24,
                borderRadius: "2px",
                backgroundColor: "#1B75BC",
            }
        };
        return (
            <Modal isOpen={this.props.isOpen} toggle={() => this.props.hideCommonModal()} centered style={{width:400}}>
                <ModalHeader className="border-0 justify-content-center">
                    <img
                        src={this.props.payload.image}
                        className="rounded img-fluid"
                        alt=""
                        width="88"
                        height="88"
                    />
                </ModalHeader>
                <ModalBody className="justify-content-center">
                    <h4 className="text-center mb-2" style={awaitStyle.awaitHead}>
                        {
                            this.props.payload.title
                        }
                    </h4>
                    <p className="text-center" style={awaitStyle.awaitBody}>
                        {
                            this.props.payload.description
                        }
                    </p>
                </ModalBody>
                {
                    this.props.isConfirmationModal
                        ?
                        <ModalFooter className="border-0 justify-content-center">
                            <div className="no-padding" style={awaitStyle.confirmationContainer}>
                                <div>
                                    <button className="btn btn-outline-primary"
                                            onClick={() => {
                                                this.props.actionArray[0].click();
                                                this.props.hideCommonModal();
                                            }}
                                            style={awaitStyle.confirmationNegativeBtn}>
                                        <span style={awaitStyle.confirmationNegativeBtnText}>{this.props.actionArray[0].text}</span>
                                    </button>
                                </div>
                                <div>
                                    <button className="btn btn-primary"
                                            onClick={() => {
                                                this.props.actionArray[1].click();
                                                this.props.hideCommonModal();
                                            }}
                                            style={awaitStyle.confirmationPositiveBtn}>
                                        <span style={awaitStyle.okButtonText}>{this.props.actionArray[1].text}</span>
                                    </button>
                                </div>

                            </div>
                        </ModalFooter>
                        :
                        <ModalFooter className="border-0 justify-content-center">
                            <Button
                                color="primary"
                                className="px-5"
                                onClick={() => {
                                    this.props.payload.action.click();
                                    this.props.hideCommonModal();
                                }}
                                style={awaitStyle.okButton}
                            >
                        <span style={awaitStyle.okButtonText}>
                            {
                                this.props.payload.action.text
                            }
                        </span>
                            </Button>

                        </ModalFooter>
                }
            </Modal>
        );
    }
}

CommanModal.propTypes = {
    payload: PropTypes.object.isRequired,
    isOpen: PropTypes.bool.isRequired,
    hideCommonModal: PropTypes.func.isRequired,
    isConfirmationModal: PropTypes.bool,
    actionArray: PropTypes.array,
};

// Specifies the default values for props:
CommanModal.defaultProps = {
    payload: {
        image: assets.awaiting_stopwatch,
        title: "Title",
        description: "Description",
        action: {
            text: "OK",
            click: () => {
            }
        }
    },
    isOpen: false,
    hideCommonModal: () => {
    },
    isConfirmationModal: false,
    actionArray: [{
        text: "CANCEL",
        click: () => {
        }
    }, {
        text: "OK",
        click: () => {
        }
    }]
};

export default CommanModal;